





















































































































































import cambioscontrasenasperdidasModule from "@/store/modules/cambioscontrasenasperdidas-module";
import { Component, Vue } from "vue-property-decorator";
import { cambioscontrasenasperdidas } from "@/shared/dtos/cambioscontrasenasperdidas";
import { UtilsString } from "@/utils/utils-string";
import { RouterNames } from "@/router/routernames";
import { AppConfig } from "@/config/app";
import { MessageService } from "@/shared/services/message-service";
import { UtilsURLS } from "@/utils/utils-urls";
import { ThemeConfig } from "@/config/theme";

@Component({ $_veeValidate: { validator: "new" } })
export default class pwdlostConfirm extends Vue {
  private contrasena: string = "";
  private rptcontrasena: string = "";
  private objpwslost = new cambioscontrasenasperdidas();
  private showPassword: boolean = false;
  private loading: boolean = false;
  private successDialog: boolean = false;

  get projectName() {
    return process.env.VUE_APP_TITLE || AppConfig.name || "App Base";
  }

  get clientLogo() {
    return UtilsURLS.urls("logo_cliente.png");
  }

  get passwordStrength(): number {
    const pwd = this.contrasena;
    let strength = 0;

    if (pwd.length >= 8) strength++;
    if (pwd.length >= 12) strength++;
    if (/[a-z]/.test(pwd) && /[A-Z]/.test(pwd)) strength++;
    if (/\d/.test(pwd)) strength++;
    if (/[!@#$%^&*(),.?":{}|<>]/.test(pwd)) strength++;

    return strength;
  }

  get passwordStrengthType(): string {
    const strength = this.passwordStrength;
    if (strength <= 1) return "error";
    if (strength <= 2) return "warning";
    if (strength <= 3) return "info";
    return "success";
  }

  get passwordStrengthIcon(): string {
    const strength = this.passwordStrength;
    if (strength <= 1) return "mdi-shield-alert";
    if (strength <= 2) return "mdi-shield-half-full";
    if (strength <= 3) return "mdi-shield-check";
    return "mdi-shield-check";
  }

  get passwordStrengthText(): string {
    const strength = this.passwordStrength;
    if (strength <= 1)
      return "Contraseña débil - Añade más caracteres y variedad";
    if (strength <= 2)
      return "Contraseña moderada - Considera añadir caracteres especiales";
    if (strength <= 3) return "Contraseña buena - Está bien protegida";
    return "Contraseña excelente - Muy segura";
  }

  private async submit() {
    const allOk = await this.$validator.validateAll();
    if (allOk) {
      this.loading = true;
      this.objpwslost.nueva_contra = this.contrasena;
      this.objpwslost.token_generado = UtilsString.ValueOf(
        this.$route.params.token
      );

      try {
        await cambioscontrasenasperdidasModule.validarcambiodecontrasena(
          this.objpwslost
        );

        this.successDialog = true;
        MessageService.toast("Contraseña actualizada", "success");

        // Redirect after 2 seconds
        setTimeout(() => {
          this.$router.push({ name: RouterNames.Login });
        }, 2000);
      } catch (error) {
        console.error("Error changing password:", error);
        MessageService.toast("Error al actualizar contraseña", "error");
      } finally {
        this.loading = false;
      }
    }
  }
}
